import React from "react";
import { useOrderAttributeProvider } from "../context/order";

const EditOrderPayment = () => {
  const { orderDetail } = useOrderAttributeProvider();
  const transaction =
    orderDetail?.order_transaction?.order_payment_transactions[0];
  return (
    <div
      className={`d-flex justify-content-between align-items-center`}
      style={{
        backgroundColor: "rgba(203, 153, 141, 0.1)",
        padding: "10px 20px",
        color: "#7d858c",
        }}
    >
      {transaction?.transaction_type !== "paypal" && (
        <p
          className="m-0"
          style={{
            whiteSpace: "break-spaces",
            wordBreak: "break-all",
            fontSize: 18,
            fontWeight: 300,
            lineHeight: "1.5",
          }}
        >
          xxx xxxx {transaction?.card_last_4_digits}
          {transaction?.card_type && <span style={{ textTransform: "capitalize" }}> {transaction.card_type}</span>}
        </p>
      )}
      {transaction?.transaction_type === "paypal" && (
        <p
          className="m-0"
          style={{
            whiteSpace: "break-spaces",
            wordBreak: "break-all",
            fontSize: 18,
            fontWeight: 300,
            lineHeight: "1.5",
          }}
        >
          {transaction?.card_last_4_digits}
          {transaction?.card_type && <span style={{ textTransform: "capitalize" }}> {transaction.card_type}</span>}
        </p>
      )}
      {/* <img
        style={{ filter: "grayscale(1)" }}
        height={25}
        src={getCardImage("")}
        alt={""}
      /> */}
    </div>
  );
};

export default EditOrderPayment;
